"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountDownTimer = void 0;
const types_1 = require("./types");
const defaultOptions = {
    timeout: 0,
    warningTimeout: 0
};
class CountDownTimer {
    constructor(options = {}) {
        this.defaultTimer = 0;
        this.warningTimer = 0;
        this.options = { ...defaultOptions, ...options };
    }
    clear() {
        clearTimeout(this.defaultTimer);
        clearTimeout(this.warningTimer);
    }
    reset() {
        this.triggerEvent(types_1.TimerEventType.reset);
        this.clear();
        this.start();
    }
    start() {
        if (!this.isTimeoutValid()) {
            return;
        }
        const { timeout, warningTimeout } = this.options;
        if (timeout > 0) {
            this.defaultTimer = window.setTimeout(() => this.triggerEvent(types_1.TimerEventType.end), timeout - warningTimeout);
        }
        if (warningTimeout > 0) {
            this.warningTimer = window.setTimeout(() => this.triggerEvent(types_1.TimerEventType.warn), warningTimeout);
        }
        this.triggerEvent(types_1.TimerEventType.start);
    }
    isTimeoutValid() {
        const { timeout, warningTimeout } = this.options;
        if (timeout < warningTimeout) {
            throw new Error('Warning timeout cannot be greater than default timeout');
        }
        return true;
    }
    triggerEvent(eventType) {
        const { options } = this;
        const handler = options[eventType];
        if (handler instanceof Function) {
            handler();
        }
    }
}
exports.CountDownTimer = CountDownTimer;
//# sourceMappingURL=count-down-timer.js.map